import Table from "./Table";
import { NumberCell } from "./TBody/NumberCell";

export default Table;
export { NumberCell };
